import { container } from 'src/StaticContainer';

const log = container.get('Logger').getSubLogger({ name: 'symbol-picker' });

export { log as logger };
